import axios from 'axios';
import { buildAuthHeaders, hasAuthSession } from './authSession';

// API Base URL - This should match your backend URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use((config) => {
  Object.assign(config.headers, buildAuthHeaders());
  return config;
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const isAuthenticated = () => hasAuthSession();

// SFP Application Form API endpoints
export const sfpApplicationFormAPI = {
  // Get form by ID
  getFormById: async (formId) => {
    try {
      const response = await apiClient.get(`/v3/sfp/forms/${formId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching form by ID:', error);
      throw error;
    }
  },

  // Create new form
  createForm: async (formData) => {
    try {
      const response = await apiClient.post('/v3/sfp/forms', formData);
      return response.data;
    } catch (error) {
      console.error('Error creating form:', error);
      throw error;
    }
  },

  // Update form
  updateForm: async (formId, formData) => {
    try {
      const response = await apiClient.put(`/v3/sfp/forms/${formId}`, formData);
      return response.data;
    } catch (error) {
      console.error('Error updating form:', error);
      throw error;
    }
  },

  // Get forms by SFP ID
  getFormsBySFP: async (sfpId) => {
    try {
      const response = await apiClient.get(`/v3/sfp/forms/sfp/${sfpId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching forms by SFP:', error);
      throw error;
    }
  },

  // Publish form
  publishForm: async (formId) => {
    try {
      const response = await apiClient.post(`/v3/sfp/forms/${formId}/publish`);
      return response.data;
    } catch (error) {
      console.error('Error publishing form:', error);
      throw error;
    }
  },

  // Clone form
  cloneForm: async (formId) => {
    try {
      const response = await apiClient.post(`/v3/sfp/forms/${formId}/clone`);
      return response.data;
    } catch (error) {
      console.error('Error cloning form:', error);
      throw error;
    }
  }
};

export default apiClient; 